import React, { useState, useEffect } from 'react';
import api from '../../api/auth';

const TeacherExams = () => {
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchExams();
  }, []);

  const fetchExams = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await api.get('/teacher/exams', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setExams(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Erreur:', err);
      setExams([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };

  if (loading) return <div className="p-6">Chargement...</div>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-[#2C3E50]">📅 Calendrier des compositions</h1>
        <p className="text-gray-500">
          Consultez les compositions planifiées par l'administration
        </p>
      </div>

      {exams.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-8 text-center text-gray-500">
          <p className="text-lg mb-2">📭 Aucune composition planifiée</p>
          <p className="text-sm">
            Les compositions sont créées et publiées par l'administration.
          </p>
          <p className="text-sm mt-4">
            Consultez régulièrement cette page pour voir les nouvelles compositions.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {exams.map((exam) => (
            <div key={exam.id} className="bg-white rounded-xl shadow-md p-5 border-l-4 border-purple-500">
              <div className="flex justify-between items-start mb-3">
                <div>
                  <h3 className="font-bold text-[#2C3E50]">{exam.title}</h3>
                  <p className="text-sm text-gray-500">{exam.class_name}</p>
                </div>
                <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded-full text-xs">
                  {exam.subject}
                </span>
              </div>

              <div className="space-y-1 text-sm">
                <p>📅 <strong>Date :</strong> {formatDate(exam.date)}</p>
                <p>🕐 <strong>Heure :</strong> {exam.start_time || '-'}</p>
                <p>⚖️ <strong>Coefficient :</strong> {exam.coefficient}</p>
              </div>

              {exam.topics && (
                <div className="mt-3 p-2 bg-gray-50 rounded">
                  <p className="text-xs text-gray-500">📚 Programme :</p>
                  <p className="text-sm">{exam.topics}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TeacherExams;